import { motion } from "framer-motion";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { COMPANY, CERTIFICATIONS } from "@/data/products";
import { waGeneral } from "@/lib/whatsapp";

export const ContactCTA = () => {
    return (
        <section id="contact" className="relative py-24 md:py-32 bg-brand-red text-bone overflow-hidden" data-testid="contact-cta">
            <div
                className="absolute inset-0 opacity-[0.06] pointer-events-none"
                style={{
                    backgroundImage:
                        "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
                }}
            />
            <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 md:col-span-7">
                        <div className="font-mono text-[10px] uppercase tracking-widest text-bone/70">
                            Chapter · 07 / Get in touch
                        </div>
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1 }}
                            className="mt-4 font-display text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-[-0.02em]"
                        >
                            Ready to
                            <br />
                            <span className="italic">paint it</span> beautifully?
                        </motion.h2>
                        <p className="mt-6 text-bone/80 max-w-lg text-lg">
                            Send us a colour, a project brief, or a photograph. We reply on WhatsApp
                            within business hours — same day, Sunday to Thursday.
                        </p>

                        <div className="mt-10 flex flex-wrap gap-3">
                            <a
                                href={waGeneral()}
                                target="_blank"
                                rel="noreferrer"
                                className="btn-pill bg-ink text-bone hover:bg-brand-yellow hover:text-ink"
                                data-testid="contact-whatsapp"
                            >
                                <MessageCircle size={16} /> Chat on WhatsApp
                            </a>
                            <a
                                href={`tel:${COMPANY.phoneRaw}`}
                                className="btn-pill border border-bone/40 hover:bg-bone hover:text-ink"
                                data-testid="contact-call"
                            >
                                <Phone size={16} /> Call {COMPANY.phone}
                            </a>
                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-5 md:pl-8">
                        <div className="grid gap-6 md:gap-8 md:pt-6">
                            <div>
                                <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-bone/60">
                                    <MapPin size={12} /> Studio
                                </div>
                                <address className="mt-2 not-italic font-display text-2xl leading-snug space-y-1">
                                    {COMPANY.addressLines.map((line) => (
                                        <div key={line}>{line}</div>
                                    ))}
                                </address>
                            </div>
                            <div>
                                <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-bone/60">
                                    <Mail size={12} /> Email
                                </div>
                                <a
                                    href={`mailto:${COMPANY.email}`}
                                    className="mt-2 block font-display text-2xl leading-snug hover:underline"
                                    data-testid="contact-email"
                                >
                                    {COMPANY.email}
                                </a>
                            </div>
                            <div>
                                <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-bone/60">
                                    Web
                                </div>
                                <div className="mt-2 font-display text-2xl leading-snug">
                                    {COMPANY.website}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-10 border-t border-bone/25 flex flex-wrap gap-x-6 gap-y-2 text-xs font-mono uppercase tracking-widest text-bone/70">
                    {CERTIFICATIONS.map((c) => (
                        <span key={c}>{c}</span>
                    ))}
                </div>
            </div>
        </section>
    );
};
